import { SecureStorage } from '@aparajita/capacitor-secure-storage';
import { isNative } from './env';

// Encrypted key/value store for the bearer token and any other secrets.
// iOS: Keychain (SPM-supported plugin, Capacitor 8 compatible).
// Android: EncryptedSharedPreferences.
// Web: deliberately a no-op (spec 000211 Q4). The web app keeps the token in the
// `isLoggedIn` cookie only, exactly as before the native layer; a second web copy
// in sessionStorage would outlive a cookie logout and be preferred on the next boot.

export async function secureGet(key) {
    if (!isNative) return null;
    try {
        const value = await SecureStorage.get(key);
        if (value == null) return null;
        return typeof value === 'string' ? value : String(value);
    } catch {
        return null;
    }
}

export async function secureSet(key, value) {
    if (!isNative) return;
    if (value == null) {
        return secureRemove(key);
    }
    await SecureStorage.set(key, String(value));
}

export async function secureRemove(key) {
    if (!isNative) return;
    try {
        await SecureStorage.remove(key);
    } catch {
        // ignore — already absent
    }
}

export async function secureClear() {
    if (!isNative) return;
    try {
        await SecureStorage.clear();
    } catch {
        // ignore
    }
}
